import * as React from 'react';

import Undo16 from './Undo16';

export const undo16 = () => <Undo16 />;

export default {
    title: 'Icon/Line/Undo16',
    component: Undo16,
    parameters: {
        notes: "`import Undo16 from 'box-ui-elements/es/icon/line/Undo16';`",
    },
};
